import { cva } from 'class-variance-authority'

export const badgeStyles = cva(
  `
    inline-flex
    items-center
    rounded-lg
    px-3
    py-1.5
    text-sm
    font-normal
    transition-[background-color] duration-150 ease-in-out
    focus:outline-none
    focus:ring-2
    focus:ring-ring
    focus:ring-offset-2
  `,
  {
    variants: {
      variant: {
        default: 'border-transparent hover:bg-primary/80',
        secondary: 'border-transparent hover:bg-secondary/80',
      },
      size: {
        sm: 'px-2 py-1',
        md: 'px-3 py-1.5',
        lg: 'px-4 py-2',
      },
      color: {
        green: '',
        olive: '',
        orange: '',
        red: '',
        yellow: '',
        purple: '',
        blue: '',
        pink: '',
        gray: '',
        white: '',
      },
    },
    compoundVariants: [
      {
        variant: 'default',
        color: 'green',
        class: 'bg-green-100 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'green',
        class: 'bg-green-25 text-green-200',
      },
      // olive
      {
        variant: 'default',
        color: 'olive',
        class: 'bg-moss-200 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'olive',
        class: 'bg-moss-25 text-moss-200',
      },
      // orange
      {
        variant: 'default',
        color: 'orange',
        class: 'bg-orange-200 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'orange',
        class: 'bg-orange-25 text-orange-200',
      },

      // red
      {
        variant: 'default',
        color: 'red',
        class: 'bg-red-100 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'red',
        class: 'bg-red-25 text-red-200',
      },

      // yellow
      {
        variant: 'default',
        color: 'yellow',
        class: 'bg-yellow-200 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'yellow',
        class: 'bg-yellow-25 text-yellow-200',
      },

      // purple
      {
        variant: 'default',
        color: 'purple',
        class: 'bg-purple-100 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'purple',
        class: 'bg-purple-25 text-purple-200',
      },

      // blue
      {
        variant: 'default',
        color: 'blue',
        class: 'bg-blue-100 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'blue',
        class: 'bg-blue-25 text-blue-200',
      },

      // magenta (pink)
      {
        variant: 'default',
        color: 'pink',
        class: 'bg-pink-100 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'pink',
        class: 'bg-pink-25 text-pink-200',
      },

      // gray
      {
        variant: 'default',
        color: 'gray',
        class: 'bg-neutral-600 text-neutral-0',
      },
      {
        variant: 'secondary',
        color: 'gray',
        class: 'bg-neutral-100 text-neutral-800',
      },

      // white
      {
        variant: 'default',
        color: 'white',
        class: 'bg-neutral-0 text-neutral-600 border-1 border-neutral-200',
      },
      {
        variant: 'secondary',
        color: 'white',
        class: 'bg-neutral-0 text-neutral-600 border-1 border-neutral-200',
      },
    ],
    defaultVariants: {
      variant: 'default',
      color: 'green',
    },
  }
)
